
/* injects from baggage-loader */

'use strict';

import assignmentTemplate from '!!file-loader?name=templates/[name].[ext]!./assignment.html';

/**
* Function that register the all routes for the assignment module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the assignment page.
	*/
	const indexNav = 6;
	const indexSubmenu = 1;
	const assignmentRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: assignmentTemplate,
			controller: 'AssignmentController',
			controllerAs: 'assignmentvm',
			resolve: {
				assignment: assignmentLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([assignmentRoute]);
}

/**
* Function for the lazyLoading configuration in the assignment route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function assignmentLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const assignmentModule = require('./assignment.module');

		$ocLazyLoad.load({
			name: assignmentModule.default.name,
		});

		deferred.resolve(assignmentModule.default.controller);
	});

	return deferred.promise;
}

export default angular
.module('assignment.routes', [])
.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/assignment/assignment.routes.js